export const DAY_PASS_SUMMARY_TITLE = 'Day Pass Summary';
export const NUMBER_OF_DAY_PASSES = '# of Day Passes';
export const VALID_ON = 'Valid On';
export const FULL_DAY_RETAIL_WATER_PARK_PASS = 'Full Day Retail Water Park Pass';
export const FULL_DAY_PASSES_COUNT = '<COUNT> Full Day <PASS>';
export const SEASON_PASS_NAME = '<SEASON_PASS_NAME> Season Pass #<SEASON_PASS_ID>';
export const ANYTIME = 'Anytime';
export const WEEKDAY = 'Weekday';
export const APPLIED = 'Applied';
export const TAXES = 'Taxes';
export const TOTAL = 'Total';
export const ZERO_AMOUNT = '$0.00';
